module.exports = __webpack_public_path__ + "static/media/backups.d5145512.svg";